"use client"

import { useEffect } from "react"
import { useSearchParams } from "next/navigation"
import { trackInstallGuideViewed, trackGuideVisitedPostDownload } from "@/lib/tracking"
import { consumeDownloadAttribution } from "@/lib/download-attribution"

export default function GuidePageTracker() {
  // eslint-disable-next-line react-doctor/nextjs-no-use-search-params-without-suspense
  const searchParams = useSearchParams()

  useEffect(() => {
    const entrySource = searchParams.get("entry") || "direct"
    trackInstallGuideViewed({
      source: "guide_page",
      entry_source: entrySource,
    })

    const attr = consumeDownloadAttribution()
    if (attr) {
      trackGuideVisitedPostDownload({
        sound_id: attr.sound_id,
        sound_title: attr.sound_title,
        download_source: attr.source,
        seconds_since_download: Math.round((Date.now() - attr.ts) / 1000),
      })
    }
  }, [searchParams])

  return null
}